<div class="card">
    <div class="card-body">
        <div class="row mb-2">
            <div class="col-6">
                <h5 class="mt-0 mb-2">
                    Experiencia laboral
                </h5>
            </div>
            <div class="col-6">
                <div class="text-end">
                    <button type="button" (click)="add()" class="btn btn-outline-primary btn-sm" data-bs-toggle="modal"
                        data-bs-target="#modalExperienciaLaboral">
                        <i class="fa-regular fa-square-plus"></i>
                        Nuevo
                    </button>
                </div>
            </div>
        </div>
        <div class="table-responsive mb-2">
            <table class="table table-hover table-theme">
                <thead>
                    <tr>
                        <th>Cargo desempeñado</th>
                        <th>Empresa</th>
                        <th>Periodo</th>
                        <th>Rango Salarial</th>
                        <th>Trabajo actual</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of employments(); let index = $index; track $index) {
                    <tr>
                        <td class="text-left">{{item.position}}</td>
                        <td class="text-left">{{item.company}}</td>
                        <td class="text-left">{{item.startDate | date : 'dd/MM/yyyy'}} - {{item.endDate | date :
                            'dd/MM/yyyy'}}
                            @if (item.currentJob && item.endDate == null) {
                                Actualmente
                            }
                        </td>
                        <td class="text-left">{{item.salaryExpectation}}</td>
                        <td class="text-left">{{item.currentJob ? 'Si' : 'No'}}</td>
                        <td class="text-center">
                            <button (click)="editResumeEmployment(item, index)" type="button"
                                class="btn btn-outline-success me-2" data-bs-toggle="modal"
                                data-bs-target="#modalExperienciaLaboral">
                                <i class="fa-solid fa-pen-to-square"></i>
                            </button>
                            <button (click)="deleteResumeEmployment(item, index)" type="button"
                                class="btn btn-outline-danger">
                                <i class="fa-regular fa-trash-can"></i>
                            </button>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>

<app-modal-employment
[resumeId]="resumeId()"
(onResumeEmployment)="handlerResumeEmployment($event)">